import { auth } from "./firebase";

import { useEffect } from "react";
import { useHistory } from "react-router-dom";

function App() {
  const history = useHistory();
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      if (u) {
        history.push("/home");
      } else {
        history.push("/auth/login");
      }
    });
    return unsub;
  }, [history]);

  return <div />;
}

export default App;
